import { setTestData } from './handleOnChange';
export const previewData = (selectedTest: any, editTestDetails: any, handleSetState: Function) => {
  
  let updateSelectedTest: any = { ...selectedTest };
  updateSelectedTest.displayName = editTestDetails.name;
  updateSelectedTest.duration = editTestDetails.duration;
  updateSelectedTest.startTime = new Date(editTestDetails.startDate);
  updateSelectedTest.endTime = new Date(editTestDetails.endDate);
  updateSelectedTest.scheduleDate = new Date(editTestDetails.startDate);
  updateSelectedTest.scheduleEndDate = new Date(editTestDetails.endDate);
  updateSelectedTest.maxAttempt = editTestDetails.maxAttempts;
  
  updateSelectedTest.blockRevisionTime = editTestDetails.revisionTime;
  handleSetState({
    selectedTest: updateSelectedTest,
  });
};

export const refinedEditData = async (selectedTest: any, editTestDetails: any, handleSetState: Function) => {
  
  let updateSelectedTest: any = { ...selectedTest };
  updateSelectedTest.displayName = editTestDetails.name;
  updateSelectedTest.duration = editTestDetails.duration;
  updateSelectedTest.startTime = new Date(editTestDetails.startDate);
  updateSelectedTest.endTime = editTestDetails.endDate ? new Date(editTestDetails.endDate) : '';
  updateSelectedTest.scheduleDate = new Date(editTestDetails.startDate);
  updateSelectedTest.scheduleEndDate = (editTestDetails.endDate) ? new Date(editTestDetails.endDate): '';
  updateSelectedTest.maxAttempt = editTestDetails.maxAttempts > 0 ? editTestDetails.maxAttempts : null;
  updateSelectedTest.questionsCount= editTestDetails.questionsCount;
  updateSelectedTest.blockRevisionTime = editTestDetails.revisionTime;
  updateSelectedTest.scheduleID = editTestDetails.scheduleID;
  updateSelectedTest.courseId = editTestDetails.courseId;
  updateSelectedTest.paperDetail.syllabus = editTestDetails.syllabus || '';
  updateSelectedTest.paperDetail.name = editTestDetails.name;
  updateSelectedTest.paperDetail.duration = editTestDetails.duration;
  updateSelectedTest.paperDetail.displayName = editTestDetails.name;
  updateSelectedTest.paperDetail.scheduleID = editTestDetails.scheduleID;
  updateSelectedTest.paperDetail.scheduleDate = editTestDetails.startDate;
  updateSelectedTest.paperDetail.startTime = editTestDetails.startDate;
  updateSelectedTest.paperDetail.scheduleEndDate = editTestDetails.endDate;
  updateSelectedTest.paperDetail.endTime = editTestDetails.endDate;
  updateSelectedTest.paperDetail.maxAttempt = editTestDetails.maxAttempts > 0 ? editTestDetails.maxAttempts : null;
  updateSelectedTest.paperDetail.questionsCount = editTestDetails.questionsCount;
  updateSelectedTest.paperDetail.blockRevisionTime = editTestDetails.revisionTime;
  editTestDetails.testId && editTestDetails.testId !== '000000000000000000000000' && await setTestData(editTestDetails.testId, handleSetState);
  

  handleSetState({
    selectedTest: JSON.parse(JSON.stringify(updateSelectedTest)),
    overAllData: JSON.parse(JSON.stringify(editTestDetails)),
    isTestMapped: editTestDetails.testId && editTestDetails.testId !== '000000000000000000000000' ? true : false
  });
};

export  const defaultPaperDetail = {
  paperDetail: {
    syllabus: '',
    id: '',
    name: '',
    type: '',
    testType: '',
    duration: '',
    status: '',
    codeName: '',
    displayName: '',
    scheduleID: '',
    scheduleDate: '',
    startTime: '',
    scheduleEndDate: '',
    endTime: '',
    maxAttempt: '',
    blockRevisionTime: '',
    // _id:''
  }
}